import { css } from '@emotion/css';

export const content = css`
    position: relative;
    padding: 24px 15px 48px 15px;
    height: 100%;
    max-height: calc(100% - 65px);
    overflow: auto;
`;